import { Phone, Mail, MapPin, Globe } from "lucide-react";
import { PageHero } from "@/components/site/PageHero";
import { FadeUp } from "@/components/site/Reveal";
import { QuoteForm } from "@/components/site/QuoteForm";
import { CONTACT } from "@/lib/content";

export default function Contact() {
  return (
    <div data-testid="contact-page">
      <PageHero testId="contact-hero" eyebrow="Free site assessment" lines={["Let's talk", "about your site."]} intro="Tell us a little about your carwash. We'll talk through your site, your power bills and the issues — and how to solve them for good, easily and simply." />
      <section className="bg-[var(--ink)] pb-24 lg:pb-32">
        <div className="mx-auto max-w-[1440px] px-5 lg:px-10 grid lg:grid-cols-12 gap-8">
          <FadeUp className="lg:col-span-7"><QuoteForm /></FadeUp>
          <FadeUp delay={0.1} className="lg:col-span-5 flex flex-col gap-4">
            <a href={CONTACT.hotlineHref} data-testid="contact-hotline" className="group rounded-2xl bg-[var(--sun)] text-[var(--ink)] p-8 transition-transform duration-300 hover:-translate-y-1">
              <p className="font-mono text-xs tracking-[0.2em] uppercase">Call us today</p>
              <p className="mt-2 font-display font-black text-5xl sm:text-6xl flex items-center gap-3"><Phone size={34} /> {CONTACT.hotline}</p>
            </a>
            {CONTACT.people.map((p) => (
              <div key={p.id} data-testid={`contact-person-${p.id}`} className="rounded-2xl border border-white/10 bg-[var(--surface)] p-7">
                <p className="font-mono text-xs tracking-[0.2em] uppercase text-[var(--solar-light)]">{p.role}</p>
                <p className="mt-1 font-display font-black uppercase text-3xl">{p.name}</p>
                <a href={p.href} className="mt-3 flex items-center gap-2 text-white hover:text-[var(--sun)] transition-colors"><Phone size={15} /> {p.phone}</a>
                <a href={`mailto:${p.email}`} className="mt-1 flex items-center gap-2 text-slate-300 hover:text-[var(--sun)] transition-colors break-all"><Mail size={15} /> {p.email}</a>
              </div>
            ))}
            <div className="rounded-2xl border border-white/10 p-7 space-y-3 text-slate-300">
              <p className="flex items-start gap-3"><MapPin size={16} className="mt-1 text-[var(--sun)] shrink-0" /> {CONTACT.office}</p>
              <p className="flex items-center gap-3"><Globe size={16} className="text-[var(--sun)]" /> {CONTACT.web} · {CONTACT.parentWeb}</p>
            </div>
          </FadeUp>
        </div>
      </section>
    </div>
  );
}
